import { type WithSlots } from '@blaze-runtime/engine-domain';

import { registerElementDefinition } from '../../services/element-definitions.service';

import { WrapperComponent } from './wrapper.component';
import { WRAPPER_HEADER_SLOT_ID, WRAPPER_MAIN_ELEMENT_SLOT_ID } from './wrapper.models';

export type WrapperDef = WithSlots<'main' | 'header'>;

// Extend the CanvasElementDefinitions type
declare module '@blaze-runtime/engine-domain' {
  interface CanvasElementDefinitions {
    wrapper: WrapperDef;
  }
}

const INITIAL_WIDTH = 380;
const INITIAL_HEIGHT = 420;

registerElementDefinition({
  type: 'wrapper',
  componentType: WrapperComponent,
  isListed: false,
  name: 'Wrapper',
  width: { mode: 'auto', value: INITIAL_WIDTH, fixed: false },
  height: { mode: 'auto', value: INITIAL_HEIGHT, fixed: false },
  slots: {
    ids: [WRAPPER_MAIN_ELEMENT_SLOT_ID, WRAPPER_HEADER_SLOT_ID],
    [WRAPPER_MAIN_ELEMENT_SLOT_ID]: {
      children: [],
    },
    [WRAPPER_HEADER_SLOT_ID]: {
      children: [],
    },
  },
  version: 1,
});
